export { default } from "@src/features/contacts/components/AddSmsContact";
